import { useState } from 'react';
import { Box, Flex, Text } from 'rebass';
import ThemeSwitcher, { getValue } from './ThemeSwitcher';

import Button from './components/Button';
import { useTabs } from './components/Tabs';
import ExampleContent from './ExampleContent';
import Components from './Components';
import Tokens, { makeGroupsFromTokens } from './Tokens';
import Palettes from './Palettes';
import CopyTextToClipboard from './components/CopyTextToClipboard';

function App() {
  const tabs = [
    {
      label: 'Palettes',
      render: () => <Palettes selectedTheme={selectedTheme} />
    },
    {
      label: 'Tokens',
      render: () => <Tokens selectedTheme={selectedTheme} />
    },
    {
      label: 'Components',
      render: () => <Components />
    },
    {
      label: 'Example content',
      render: () => <ExampleContent />
    },
  ];
  const [selectedTheme, setTheme] = useState(null);
  const { verticalTabControls, horizontalTabControls, tabContent } = useTabs({ 
    tabs,
    verticalTabControls: true,
    defaultSelectTab: 0,
  });

  const makeFigmaTokenObjectFromTheme = () => {
    if (!selectedTheme) return;

    const figmaTokenObject = {};
    const tokens = selectedTheme.themes[selectedTheme.theme];
    const groups = makeGroupsFromTokens(tokens, true, '');

    groups.forEach(group => {
      const result = {};

      if (group.label === 'Scales') {
        // loop through each scale
        Object.keys(group.colors).forEach(scaleKey => {

          const scaleColors = group.colors[scaleKey];

          Object.keys(scaleColors).forEach(token => {
            result[token] = {
              value: getValue(token, tokens, 'figma'),
              type: 'color',
            };
          });
        })

      } else {
        Object.keys(group.colors).forEach(token => {
          result[token] = {
            value: getValue(token, tokens, 'figma'),
            type: 'color',
          };
        });
      }

      figmaTokenObject[group.label] = result;
    })

    return figmaTokenObject;
  };


  const makeJSONTokens = () => {
    if (!selectedTheme) return;

    const tokens = selectedTheme.themes[selectedTheme.theme]
    const tokensWithValues = Object.keys(tokens).reduce((acc, key) => {
      acc[key] = getValue(key, tokens, 'hex');
      return acc;
    }, {});
    // return tokensWithValues;

    // remove first and last bracket from string
    const string = JSON.stringify(tokensWithValues, null, 2).replace(/^\{|\}$/g, '');
    // strip whitespace except new lines
    const json = string.replace(/  /g, '');
    return json;
  }

  const figmaTokens = makeFigmaTokenObjectFromTheme();
  const tokens = makeJSONTokens();

  return (
    <div className="App">
      <Flex
        // className="container"
        // mx="auto"
        justifyContent="space-between"
        alignItems="center"
        px={4}
        py="24px"
        css={`
          background: var(--backgroundGraySubtle);
          border-bottom: 1px solid var(--borderNeutralMutedAlpha);
        `}
      >
        <Box css="flex: 3;">
          <Text as="h3" letterSpacing="-.5px">🎨 &nbsp; KickUp Color System <Text fontWeight="400" display="inline">2022</Text></Text>
        </Box>
        <Box css="flex: 1;">
          <Flex alignItems="center">
            {/* <Text mr={2}>Theme:</Text> */}
            <ThemeSwitcher handleSetTheme={setTheme} />
          </Flex>
        </Box>
        {/* <input type="text" placeholder="Search" /> */}
        {/* <Button>Click me</Button> */}
      </Flex>
      <Box
        p={3}
        css={`
          display: none;
          @media (max-width: 768px) {
            display: block;
          }
        `}
      >
        {horizontalTabControls}
      </Box>
      <Flex p={4}>
        <Box
          mr={5}
          css={`
            position: sticky;
            top: 24px;
            width: 200px;
            align-self: flex-start;
            @media (max-width: 768px) {
              display: none;
            }
          `}
        >
          {verticalTabControls}
          <Flex justifyContent="space-between" alignItems="center" mt={3} mb={2}>
            <Text fontSize={0} fontWeight="bold">Figma tokens</Text>
            <CopyTextToClipboard text={JSON.stringify(figmaTokens, null, 2)} />
          </Flex>
          <Box
            as="textarea"
            value={JSON.stringify(figmaTokens, null, 2)}
            css={`
              border-radius: 6px;
              font-size: 10px;
              width: 100%;
              color: var(--textNeutralSubtle);
              background: var(--backgroundNeutralMuted);
              border: 1px solid var(--borderNeutralMutedAlpha);
            `}
          />
          <Flex justifyContent="space-between" alignItems="center" mt={3} mb={2}>
            <Text fontSize={0} fontWeight="bold">JSON tokens</Text>
            <CopyTextToClipboard text={tokens} />
          </Flex>
          <Box
            as="textarea"
            value={tokens}
            css={`
              border-radius: 6px;
              font-size: 10px;
              width: 100%;
              color: var(--textNeutralSubtle);
              background: var(--backgroundNeutralMuted);
              border: 1px solid var(--borderNeutralMutedAlpha);
              resize: vertical;
            `}
          />
        </Box>
        <Box
          css={`
            width: 100%;
            max-width: 1400px;
          `}
        >
          {tabContent}
        </Box>
      </Flex>
    </div>
  );
}

export default App;
